import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
import money from 'v-money'
Vue.use(money, {precision: 2,  masked: false})
